import { phuHuynhApi } from './../../../api/phuHuynhApi';
import { call, put, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { actions } from "../../actions/actionsWrapper";
import { eCrmPhuHuynhActionTypeIds, ICrmPhuHuynhActionTypes } from "../../action-types/crm-phuhuynh/ICrmPhuHuynhActionTypes";
import { IPhuHuynhSelectRequest } from "../../../models/request/phu-huynh/IPhuHuynhSelectRequest";

// Sagas cho học sinh
export function* crmPhuHuynhSaga(): any {
  yield takeLatest(eCrmPhuHuynhActionTypeIds.LOAD_START, loadWorker);
  //yield takeLatest(eCrmPhuHuynhActionTypeIds.SEARCH_START, searchWorker);
  yield takeLatest(eCrmPhuHuynhActionTypeIds.GET_BY_ID_START, getByIdWorker);
}

function* loadWorker(action: ICrmPhuHuynhActionTypes): any {
  const { dm_coso_id, ts_phuhuynh_adm_status_id,dm_chiendich_id } = action.payload;
  
  const res: IBaseResponeModel = yield call(
    apiWrapper.crmPhuHuynh.SelectAll,
    dm_coso_id,
    ts_phuhuynh_adm_status_id,
    dm_chiendich_id
  );
  if (res.is_success) {
    yield put(actions.crmPhuHuynh.LOAD_SUCCESS(res.data));
  } else {
    yield put(actions.crmPhuHuynh.LOAD_ERROR(res.message ?? "Error"));
  }
}


// Worker để tìm kiếm 
// function* searchWorker(action: any): any {
//   const { dm_truong_id, key } = action.payload;
//   const res: IBaseResponeModel = yield call(
//     apiWrapper.crmPhuHuynh.search,
//     dm_truong_id,
//     key
//   );
//   if (res.is_success) {
//     yield put(actions.crmPhuHuynh.LOAD_SUCCESS(res.data));
//   } else {
//     yield put(actions.crmPhuHuynh.LOAD_ERROR(res.message ?? "Error"));
//   }
// }

// Worker để lấy thông tin chi tiết theo ID
function* getByIdWorker(action: any): any {
  const { id } = action.payload;
  
  const res: IBaseResponeModel = yield call(
    apiWrapper.crmPhuHuynh.getById,
    id
  );
  if (res.is_success) {
    yield put(actions.crmPhuHuynh.GET_BY_ID_SUCCESS(res.data));
  } else {
    yield put(actions.crmPhuHuynh.LOAD_ERROR(res.message ?? "Error"));
  }
}
